import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/uppromote-import")({
  component: lazyRouteComponent(() => import("./-pages/admin.uppromote-import")),
  head: () => ({ meta: [{ title: "Lecmo · UpPromote Import" }] }),
});
